export default __webpack_public_path__ + "static/media/a-natual-mockup1.90185bdc.png";